"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTournamentAdmin = exports.isTournamentSpectator = void 0;
const app_1 = require("../../../app");
const game_1 = require("../../../modules/game");
const shared_1 = require("../../../modules/shared");
const tournament_spectate_utils_1 = require("./tournament-spectate-utils");
const isTournamentSpectator = (user, tournament) => {
    var _a;
    const userId = (0, shared_1.getEntityId)(user);
    if (!userId || !tournament)
        return false;
    const platformType = (_a = tournament === null || tournament === void 0 ? void 0 : tournament.game) === null || _a === void 0 ? void 0 : _a.platformType;
    if (platformType === game_1.PlatformType.LeagueOfLegends) {
        const spectators = tournament.spectators;
        if (!(spectators === null || spectators === void 0 ? void 0 : spectators.length)) {
            return false;
        }
        return spectators.map((spectator) => (0, shared_1.getEntityId)(spectator.user)).includes(userId);
    }
    else {
        return (0, tournament_spectate_utils_1.isTournamentSpectateEnabled)(tournament);
    }
};
exports.isTournamentSpectator = isTournamentSpectator;
const isTournamentAdmin = (user, tournament) => {
    var _a;
    const userId = (0, shared_1.getEntityId)(user);
    if (!userId || !tournament)
        return false;
    if ((0, shared_1.getEntityId)(tournament.owner) === userId)
        return true;
    if (((_a = tournament === null || tournament === void 0 ? void 0 : tournament.admins) === null || _a === void 0 ? void 0 : _a.length) && tournament.admins.map(shared_1.getEntityId).includes(userId))
        return true;
    if (user === null || user === void 0 ? void 0 : user.roles) {
        if (Array.isArray(user.roles))
            return user.roles.includes(app_1.Role.TournamentAdministrator);
        if (user.roles instanceof Set)
            return user.roles.has(app_1.Role.TournamentAdministrator);
    }
    return false;
};
exports.isTournamentAdmin = isTournamentAdmin;
//# sourceMappingURL=tournament-user-roles.js.map